














































































import { Icon } from '@iconify/vue2';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'FakeRetrievalQueryCard',
    components: { Icon },
});
